<template>
  <div class="bg-white rounded box-shadow p-3">
    <b-modal id="voucher-info-modal" size="lg" title="Voucher Info Information" hide-footer>
      <div v-show="show" class="alert alert-danger alert-dismissible fade show" role="alert">
        <span v-for="(err, index) in validation_errors" :key="index">
          {{ err[0] }} <br/>
        </span>
      </div>
      <div class="modal-content bg-white rounded box-shadow">
        <div class="form-row">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="code_pay_ep_type_id">Paid EP as <span class="c-required">*</span></label>
            <select v-model="voucher_info.code_pay_ep_type_id"  v-validate="'required'" id="code_pay_ep_type_id" name="code_pay_ep_type_id" class="form-control form-control-sm">
              <option :value="''" selected>Select Type</option>
              <option v-for="(code_pay_ep_type, index) in code_pay_ep_types" v-bind:value="code_pay_ep_type.id" :key="index">{{ code_pay_ep_type.id }} : {{ code_pay_ep_type.code_pay_ep_type_desc }}</option>
            </select>
            <div class="invalid-feedback">
              Please select valid type
            </div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="jvc_id">JVC No. <span class="c-required">*</span></label>
            <select v-model="voucher_info.jvc_id"  v-validate="'required'" id="jvc_id" name="jvc_id" class="form-control form-control-sm">
              <option :value="''" selected>Select Report</option>
              <option v-for="(jvc_report, index) in jvc_lists" v-bind:value="jvc_report.id" :key="index">JVC No.{{ jvc_report.jvc_no }}, Date : {{ jvc_report.jvc_date }}</option>
            </select>
            <div class="invalid-feedback">Please select valid JVC report</div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="voucher_no">Voucher No <span class="c-required">*</span> </label>
            <input type="text" v-model="voucher_info.voucher_no" v-validate="'required'" id="voucher_no" name="voucher_no" class="form-control form-control-sm"/>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="cheque_no">Cheque No <span class="c-required">*</span></label>
            <input type="text" v-model="voucher_info.cheque_no" v-validate="'required'" id="cheque_no" name="cheque_no" placeholder="Cheque number required" class="form-control form-control-sm"/>
            <div class="invalid-feedback">Cheque number is required</div>
          </div>
        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="cheque_date">Cheque date <span class="c-required">*</span></label>
            <datepicker v-model="voucher_info.cheque_date" v-validate="'required'" id="cheque_date" name="cheque_date" :format="customChequeDate"  placeholder="Cheque date"></datepicker>
            <div class="text-danger" style="margin-top: 0.25rem; font-size: 0.75rem;" v-if="errors.has('cheque_date')">Cheque date is required</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="cheque_date">Payment Date <span class="c-required">*</span></label>
            <datepicker v-model="voucher_info.payment_date" v-validate="'required'" id="payment_date" name="cheque_date" :format="customPaymentDate"  placeholder="Payment date"></datepicker>
            <div class="text-danger" style="margin-top: 0.25rem; font-size: 0.75rem;" v-if="errors.has('payment_date')">Payment date is required</div>
          </div>

        </div>
        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="mouza_id">Mouza<span class="c-required">*</span></label>
            <select v-model="voucher_info.mouza_id" v-validate="'required'" id="mouza_id" name="mouza_id" class="form-control form-control-sm">
              <option :value="''" selected>Select Mouza</option>
              <option v-for="(mouza, index) in mouzas" v-bind:value="mouza.id" :key="index">{{ mouza.id }} : {{ mouza.mouza_desc }}</option>
            </select>
            <div class="invalid-feedback">Please select valid mouza</div>
          </div>
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="ep_type">EP Type<span class="c-required">*</span></label>
            <select v-model="voucher_info.ep_type" v-validate="'required'" id="ep_type" name="ep_type" class="form-control form-control-sm">
              <option :value="''" selected>Select EP Type</option>
              <option value="1">1. Titled</option>
              <option value="2">2 . Non-titled</option>
            </select>
            <div class="invalid-feedback">Please select EP type</div>
          </div>
        </div>


        <div class="form-row mt-2">
          <div class="col-md-6 col-sm-6 col-lg-6">
            <label for="survey_worker_id">Worker Completed, JVC<span class="c-required">*</span></label>
            <select v-model="voucher_info.survey_worker_id" v-validate="'required'" id="survey_worker_id" name="survey_worker_id" class="form-control form-control-sm">
              <option :value="''" selected>Select Worker</option>
              <option v-for="(survey_worker, index) in survey_workers" v-bind:value="survey_worker.id" :key="index">{{ survey_worker.id }} : {{ survey_worker.name }}</option>
            </select>
            <div class="invalid-feedback">Please select valid Survey worker</div>
          </div>
        </div>





        <div class="form-row mt-3 mb-3">
          <div class="float-right">
            <b-button v-if="!this.btn_edit" class="form-control-sm mr-2" size="sm" variant="success" @click.prevent="save">Add Voucher Info</b-button>
            <b-button v-if="this.btn_edit" class="form-control-sm mr-2" size="sm" variant="warning" @click.prevent="update">Update Voucher Info</b-button>
            <b-button size="sm" variant="danger" class="form-control-sm" @click="$bvModal.hide('voucher-info-modal')">Cancel</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import http from "@state/http";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Multiselect from "vue-multiselect";

export default {
  props: ["voucher_info", "btn_edit","ses_id","jvc_lists"],

  components: { Datepicker, Multiselect },
  data() {
    return {
      code_pay_ep_types: [],
      mouzas: [],
      survey_workers:[],
      supervisors:[],
      jvc_ep_lists: [],
      validation_errors: {},
      show: false,
      district_id: '',
    };
  },
  mounted() {
    this.district_id = this.$route.params.district_id;
    this.getCodes();
  },
  methods: {
    customChequeDate(date) {
      this.voucher_info.cheque_date = moment(date).format("YYYY-MM-DD");
      return moment(date).format("YYYY-MM-DD");
    },
    customPaymentDate(date) {
      this.voucher_info.payment_date = moment(date).format("YYYY-MM-DD");
      return moment(date).format("YYYY-MM-DD");
    },
    save() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http
            .post("api/voucher-infos", this.voucher_info)
            .then(response => {
              if (!response.data.error) {
                this.$emit("resetForm");
                this.$bvModal.hide("voucher-info-modal");
                this.$bvToast.toast(response.data.message, {
                  title: "Success",
                  autoHideDelay: 5000,
                  variant: "success"
                });
                this.$emit("getVoucherInfos");
              }
              if (response.data.error == true) {
                this.$bvToast.toast(response.data.message, {
                  title: "Error",
                  autoHideDelay: 5000,
                  variant: "danger"
                });
              }
            })
            .catch(error => {
              this.validation_errors = error.response.data.errors;
              this.show = true;
              this.hide();
            });
        }
      });
    },
    update() {
      this.$validator.validate().then(valid => {
        if (valid) {
          http.put("api/voucher-infos/" + this.voucher_info.id, this.voucher_info)
            .then(response => {
              if (!response.data.error) {
                this.$bvModal.hide("voucher-info-modal");
                this.$bvToast.toast(response.data.message, {
                  title: "Success",
                  autoHideDelay: 5000,
                  variant: "success"
                });
                this.$emit("getVoucherInfos");
              }
              if (response.data.error == true) {
                this.$bvToast.toast(response.data.message, {
                  title: "Error",
                  autoHideDelay: 5000,
                  variant: "danger"
                });
              }
            })
            .catch(error => {
              this.validation_errors = error.response.data.errors;
              this.show = true;
              this.hide();
              this.$bvToast.toast("Update Failed", {
                title: "Error",
                autoHideDelay: 5000,
                variant: "danger"
              });
            });
        }
      });
    },
    getCodes() {
      http.get("api/voucher-info/codes").then(response => {
        if (!response.error) {
          let data = response.data;
          this.code_pay_ep_types = data.code_pay_ep_types;
          this.mouzas = data.mouzas;
          this.survey_workers = data.survey_workers;
          this.supervisors = data.supervisors;
        }
      });
    },
    hide() {
      setTimeout(() => {
        this.show = false;
      }, 5000);
    },
  },
};
</script>
<style>
  .c-required{
    color: red;
  }
  .vdp-datepicker input {
    width: 100%;
    border-radius: 3px;
    border: 1px solid #ced4da;
    height: 30px;
    padding-left: 15px;
    color: #6b757d;
  }
</style>
